import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { api } from '../../../Api';
import { Store } from '../../../Store';
import { getError } from '../../../utils';
import { st } from './reportUi';

/**
 * /admin/reports — the owner's report library. Each card opens one report;
 * every report has the same controls (period, search, filters, breakdown,
 * columns, PDF / CSV).
 */
export default function ReportsHomeScreen() {
  const { state } = useContext(Store);
  const { userInfo } = state;
  const [reports, setReports] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    axios
      .get(`${api}/api/owner-reports`, { headers: { Authorization: `Bearer ${userInfo.token}` } })
      .then(({ data }) => setReports(data.reports))
      .catch((err) => setError(getError(err)));
  }, [userInfo.token]);

  return (
    <div style={st.page}>
      <Helmet><title>Business Reports</title></Helmet>
      <div style={st.crumbs}>Admin / Reports</div>
      <h1 style={st.h1}>Business Reports</h1>
      <p style={st.lede}>
        Owner-level reports on sales, cash flow, member growth, commissions and staff activity. Pick a report, set the
        period and filters, choose the columns you need, and download it as a PDF or CSV.
      </p>

      {error && <div style={{ ...st.notice, background: '#fef2f2', borderColor: '#fecaca', color: '#991b1b' }}>{error}</div>}

      <div style={{ ...st.grid, gridTemplateColumns: 'repeat(auto-fit, minmax(290px, 1fr))', marginTop: 18 }}>
        {(reports || Array.from({ length: 5 })).map((r, i) => (
          <Link
            key={r?.key || i}
            to={r ? `/admin/reports/${r.key}` : '#'}
            style={{ ...st.card, margin: 0, textDecoration: 'none', color: 'inherit', display: 'flex', flexDirection: 'column', gap: 8, minHeight: 170, opacity: r ? 1 : 0.5 }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <span style={{ width: 42, height: 42, borderRadius: 10, background: '#eff6ff', color: '#1d4ed8', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>
                <i className={`fa ${r?.icon || 'fa-file-text-o'}`} aria-hidden="true" />
              </span>
              <div>
                <div style={{ fontSize: 11, fontWeight: 800, color: '#6b7280', letterSpacing: '.05em' }}>REPORT {i + 1}</div>
                <div style={{ fontSize: 17, fontWeight: 800 }}>{r?.title || 'Loading…'}</div>
              </div>
            </div>
            <p style={{ ...st.muted, fontSize: 13.5, color: '#4b5563', margin: 0, flex: 1 }}>{r?.description || ''}</p>
            {r && (
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={st.muted}>
                  {r.filters.length} filters · {r.groups.length} breakdowns · {r.columns.length} columns
                </span>
                <span style={{ color: '#2563eb', fontWeight: 700, fontSize: 13.5 }}>
                  Open <i className="fa fa-arrow-right" aria-hidden="true" />
                </span>
              </div>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
}
